import { useSelector } from 'react-redux'

export function useToken() {
  return useSelector((state) => state.auth.token)
}
